// Originally largely borrowed from https://github.com/ndimatteo/HULL/blob/d207a173970b0eba68ee067221cf45886c2f3e8d/components/photo.js

import { cn } from 'lib/utils';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { buildSrc, buildSrcSet, dprVariants } from './utils';

const Photo = ({
  photo,
  width, // Provide without height when aspect is not important (image inlined with text)
  height, // Provide when the hight/aspect ratio is important (grid of images)
  caption,
  srcSizes = null, // Array of width variants, ie: [100, 200, 300]
  sizes = null, // CSS Selectors, ie: '(min-width: 940px) 50vw, 100vw'
  fixDimension = false,
  quality = 80,
  className,
}) => {
  if (!photo) return null;

  const defaultSizes = srcSizes
    ? srcSizes
    : dprVariants.map((dpr) => dpr * width);

  // define our aspect ratio if not a background fill
  const aspect =
    typeof width === 'number' && typeof height === 'number'
      ? (height / width) * 100
      : 100 / photo.asset.metadata.dimensions.aspectRatio;

  // define our src and srcset
  const src = buildSrc(photo, {
    ...{ width },
    ...{ height },
    ...{ quality },
  });

  const srcset = buildSrcSet(photo, {
    ...{ srcSizes: defaultSizes },
    ...{ aspect },
    ...{ quality },
  });

  return (
    <figure className={className ? className : null}>
      <Image
        width={fixDimension ? width : 620}
        height={fixDimension ? height : 400}
        src={src}
        srcSet={srcset}
        sizes={sizes}
        alt={photo.alt}
        className={cn(className, 'mx-auto max-w-full')}
        placeholder={photo.asset.metadata.lqip}
      />
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
};

Photo.propTypes = {
  photo: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    asset: PropTypes.shape({
      metadata: PropTypes.shape({
        dimensions: PropTypes.shape({
          aspectRatio: PropTypes.number,
        }),
      }),
    }),
  }),
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
  caption: PropTypes.object,
  srcSizes: PropTypes.arrayOf(PropTypes.number),
  sizes: PropTypes.string,
  layout: PropTypes.string,
  fixDimension: PropTypes.bool,
  quality: PropTypes.number,
  hasPlaceholder: PropTypes.bool,
  forceLoad: PropTypes.bool,
  onLoad: PropTypes.func,
  className: PropTypes.string,
};

export default Photo;
